'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Image, { StaticImageData } from 'next/image';
import { PropsWithClassname } from '@/app/types';

import mastercardLogo from '@/public/public/images/mastercard-logo.svg';
import visaLogo from '@/public/public/images/visa-logo.svg';
import gPayLogo from '@/public/public/images/gpay-logo.svg';
import applePayLogo from '@/public/public/images/applepay-logo.svg';

interface PaymentMethodLogoItem {
  src: StaticImageData;
  alt: string;
  width: number;
  height: number;
}

const PaymentMethodLogos = ({ className }: PropsWithClassname) => {
  const { t } = useTranslation();

  const items: PaymentMethodLogoItem[] = useMemo(
    () => [
      {
        src: mastercardLogo,
        alt: t('components.PaymentMethodLogos.mastercard'),
        width: 45,
        height: 26,
      },
      {
        src: visaLogo,
        alt: t('components.PaymentMethodLogos.visa'),
        width: 55,
        height: 26,
      },
      {
        src: gPayLogo,
        alt: t('components.PaymentMethodLogos.googlePay'),
        width: 45,
        height: 26,
      },
      {
        src: applePayLogo,
        alt: t('components.PaymentMethodLogos.applePay'),
        width: 37,
        height: 26,
      },
    ],
    [t],
  );

  return (
    <div className={classNames(className, 'flex grow-0 gap-[16px]')}>
      {items.map((item, index) => (
        <Image
          key={index}
          src={item.src}
          width={item.width}
          height={item.height}
          alt={item.alt}
          className={`w-[${item.width}px] h-[${item.height}px] grow-0 mr-[8px]`}
        />
      ))}
    </div>
  );
};

export default PaymentMethodLogos;
